import { useParams } from 'react-router';
import {
  CenteredContent,
  CenteredContentLayout,
  Header,
} from '@/layouts/centered-content.layout';
import { SidebarLayout } from '@/layouts/sidebar.layout';
import { useI18nContext } from '@/i18n/i18n-react';
import { incidentContentRegistry } from '@/components/incidents/incident-content-registry';

export default function IncidentPage() {
  const { incidentSlug } = useParams();
  const { LL, locale } = useI18nContext();

  const slug = typeof incidentSlug === 'string' ? incidentSlug : '';
  const entry = incidentContentRegistry[slug];

  if (!entry) {
    return (
      <SidebarLayout className="!p-0">
        <CenteredContentLayout>
          <Header>
            <h1 className="text-lg tracking-tight sm:text-xl">
              {LL.incidentPage.title()}
            </h1>
          </Header>
          <CenteredContent className="pb-24 sm:pb-36">
            <p className="text-muted-foreground">
              {LL.incidentPage.notFound()}
            </p>
          </CenteredContent>
        </CenteredContentLayout>
      </SidebarLayout>
    );
  }

  const Content = entry.getContent(locale);

  return (
    <SidebarLayout className="!p-0">
      <CenteredContentLayout>
        <Header>
          <h1 className="text-lg tracking-tight sm:text-xl">
            {LL.incidentPage.title()}
          </h1>
        </Header>
        <CenteredContent className="pb-24 sm:pb-36">
          <div className="[&_p]:mb-3 [&_p:last-child]:mb-0 [&_p_svg]:inline-block [&_p_svg]:size-[1.05em] [&_p_svg]:align-[-0.125em] [&_code]:rounded-sm [&_code]:border [&_code]:border-border [&_code]:bg-muted [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:text-[0.8em] [&_hr]:my-4 [&_hr]:border-muted-foreground/30 prose prose-invert">
            <Content />
          </div>
        </CenteredContent>
      </CenteredContentLayout>
    </SidebarLayout>
  );
}
